// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__XVwHE","label":"Labeled_label__1L7kg","divider":"Labeled_divider__2qXPR"};